import { render, staticRenderFns } from "./IconChevronUp.vue?vue&type=template&id=5c6e7530"
import script from "./IconChevronUp.vue?vue&type=script&lang=js"
export * from "./IconChevronUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports